import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import { OpcionModel } from '../Global/Opcion.model';


@Component({
	selector : 'LegalizarEscritura',
	templateUrl : './LegalizarEscrituras.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class LegalizarEscritura {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public listaNegocios:Array<OpcionModel>;
	public listaPrefijos:Array<OpcionModel>;


	public form: FormGroup;
	public formErrors: any;
	public cnumcont:OpcionModel ;
	public ciddoc:OpcionModel ;



	public permisos:any;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public bloquear:boolean = false;
    public cargando = false;


	cnumcontControl = new FormControl();
	ciddocControl = new FormControl();
	cnumcontOptions: Observable<OpcionModel[]>;
	ciddocOptions: Observable<OpcionModel[]>;
	options = [];

	

	public contrato:string;
	public prefijo:string;
	public tipoP:string;

	public cnumdoc:string;
	public vidEscritura:string;
	@ViewChild('filter') filter: ElementRef;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog){		

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		
		this.snackBar.dismiss();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		
		this.listaNegocios = new Array();
		this.listaPrefijos = new Array();
		this.cnumdoc='';
		this.vidEscritura='';
		this.cargando = false;


		this.cnumcont = new OpcionModel("","");
		this.ciddoc = new OpcionModel("","");

		this.form = this.formBuilder.group({
			filtroCnumcont   : [
			{
				value   : this.cnumcont.labelOpcion,
				disabled: this.bloquear
			},Validators.required],
			filtroCiddoc   : [
			{
				value   : this.ciddoc.labelOpcion,
				disabled: this.bloquear
			},Validators.required],
			cnumdoc: ['', Validators.required],
			vidEscritura: ['', Validators.required]
		});

		this.formErrors = {

			cnumdoc: {},
			vidEscritura: {},

		};		
	}


	ngOnInit(){
		this._serviciosGenerales.get('listaNegocios', {ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaNegocios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));
				

				this.cnumcontOptions = this.cnumcontControl.valueChanges
				.startWith(null)
				.map(val => val ? this.filtro(val) : this.listaNegocios.slice());

				this._route.params.subscribe(params=>{
					console.log(params);
					if( !!params["cnumcont"]){
						this.tipoP = params["edi"];
						this.contrato = params["cnumcont"];
						this.prefijo = params["cprefijo"];
						for(let x in result)
							if(result[x].cnumcont.trim() == params["cnumcont"].trim())
								this.cnumcont.labelOpcion = result[x].cnumcont.trim()+' - '+result[x].vnombrenegocio.trim();
							if(!!params["ccodcon"] )
								this.eventoConsulta(params["ccodcon"]);

							if(!!params["cprefijo"] )
								this.eventoConsulta(params["cprefijo"]);
					}

				});

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la lista de negocios", "X");
			});

		
		this.listaPrefijos.push(new OpcionModel("", ""));

		this.ciddocOptions = this.ciddocControl.valueChanges
		.startWith(null)
		.map(val => val ? this.filtroPrefijo(val) : this.listaPrefijos.slice());


	}

	filtro(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}


		let x = this.listaNegocios.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		
		return x;

		
	}



	filtroPrefijo(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}


		let x = this.listaPrefijos.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		
		return x;		
	}

	eventoConsulta(opcional){
		
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
		this.listaPrefijos = new Array();
		this.ciddoc = new OpcionModel(" ", " ");
		

		this._serviciosGenerales.get('listaPrefijos', {cnumcont : this.cnumcont.idOpcion, ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));
				
				if(this.listaPrefijos.length == 0){
					this.openSnackBarEspecial("No se encontraron prefijos para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();


				this.ciddocOptions = this.ciddocControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroPrefijo(valT) : this.listaPrefijos.slice());

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}





	legalizarEscritura(){


		if (this.form.valid == false) {
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}

		this.cargando = true;
		var parametros = "{ procedimientoAntes: '-', procedimientoDespues: 'PROC_LEGALIZAR_ESCRITURAS', tablaCargue: '-',tablaCargueArchivo:'',parametrosProcDespues:{P_CNUMCONT:"+'"'+this.cnumcont.idOpcion+'"'+",P_CPREFIJO:'"+this.ciddoc.idOpcion.substring(0,this.ciddoc.idOpcion.indexOf('-')).trim()+"',P_VID_ESCRITURA:'"+this.vidEscritura+"',P_CNUMDOC:'"+this.cnumdoc+"',P_USUARIO:'"+this._serviciosGenerales.seguridad.getInfoSesion().usuario+"'}}";		
		this._serviciosGenerales.post('cargueGenerico/'+parametros,'').subscribe(
			result=>{
				
				this.cargando = false;
				if(result.mensaje=="OK"){
					this.openSnackBar("Proceso realizado con éxito.", "X");
				}else{
					this.openSnackBarEspecial(result.mensaje, "X");
				}
				
			},error=>{
				this.cargando = false;
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de Guadar el Control de Escritura", "X");
			})
	}




openSnackBar(message: string, action: string)
{
	this.snackBar.open(message, action, {
		duration: 20000
	});
}

openSnackBarEspecial(message: string, action: string) {
	let snackBarRef =  this.snackBar.open(message, action);

	snackBarRef.onAction().subscribe(() => {
		this.ocultar = false;
		this.mensaje = "";
	});
	
	let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
	
	if (shand.length != 0) {
			for (let i=0;i<shand.length;i++){
			shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
}

}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/LegalizacionEscrituras/LegalizarEscrituras.component.ts